import { GetResourceCollectionsParams, ResourceCollectionsResponse } from './types';
import { FailureActionPayload } from '../errors/types';
import { createAction, createAsyncAction } from 'typesafe-actions';

export const getResourceCollections = createAsyncAction(
  'GET_RESOURCE_COLLECTIONS_REQUEST',
  'GET_RESOURCE_COLLECTIONS_SUCCESS',
  'GET_RESOURCE_COLLECTIONS_FAILURE',
)<GetResourceCollectionsParams, ResourceCollectionsResponse, FailureActionPayload>();

export const resetResourceCollectionsState = createAction('RESET_RESOURCE_COLLECTIONS_STATE')<undefined>();
